<template>
    <div class="org-select-selected-list">
        <ul v-if="currentSelected.length">
            <li
                v-for="(item, index) in currentSelected"
                :key="index"
                :class="[item.disabled ? 'is-disabled' : '']"
            >
                <org-item
                    v-if="useOrgItem"
                    :option="item"
                >
                <span
                      slot="text"
                      v-html="item.name"
                    />
                </org-item>
                <span v-else> {{ item.name }}</span>
                <a
                    :id="item.id"
                    href="javascript:;"
                    class="org-select-selected-list-del"
                    @click="removeSelected(item.id)"
                ><v-icon name="close" /></a>
            </li>
        </ul>
    </div>
</template>

<script>
import OrgItem from '@/components/org-item';

export default {
  components: {
    OrgItem,
  },

  props: {
    selected: {
      type: Array,
      default() {
        return [];
      },
    },
    useOrgItem: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentSelected: [...this.selected] || [],
    };
  },
  watch: {
    selected(nextValue) {
      this.currentSelected = [...nextValue];
    },
  },
  methods: {
    removeSelected(id) {
      const arr = this.currentSelected.filter(item => item.id !== id);

      this.$emit('change', arr);
    },
  },
};
</script>
